import Button from '@atoms/Button/Button';
import CheckboxInput from '@atoms/Inputs/CheckboxInput';
import { vacancyFiltersType } from '@lib/proptypes';
import MatchMakerQuestion from '@molecules/MatchMaker/MatchMakerQuestion';
import { useMatchmakerQuestion } from '@utils';
import PropTypes from 'prop-types';

import styles from './Matchmaker.module.scss';

const filterKey = 'subjectAreas';

export default function Question4({ filters, handleNavigation }) {
  const {
    inputs,
    handleChange,
    hasSelectedAll,
    toggleAll,
    handlePreviousUrl,
    handleNextUrl,
  } = useMatchmakerQuestion({
    key: filterKey,
    callback: handleNavigation,
    filters,
  });

  return (
    <MatchMakerQuestion
      number={4}
      total={7}
      question="Welke doelgroep spreekt je aan?"
      extraClasses={styles.matchMakerQuestion}
    >
      <div className={styles.inputsContainer}>
        {filters.subjectAreas.map(({ id, title }) => (
          <CheckboxInput
            key={`subject-area-${id}`}
            id={id}
            value={id.toString()}
            name={filterKey}
            onChange={handleChange}
            label={title}
            checked={inputs[filterKey].includes(id.toString())}
            groupCheckbox
          />
        ))}

        <CheckboxInput
          id="subject-area-all"
          value=""
          name={filterKey}
          onChange={toggleAll}
          label="Ik vind alle doelgroepen leuk"
          checked={hasSelectedAll}
          groupCheckbox
        />
      </div>

      <p className={styles.choiceHelp}>Je mag meerdere opties aanvinken</p>

      <div className={styles.ctaContainer}>
        <Button
          key="matchmaker-back-button"
          label="Terug"
          href="/matchmaker/3"
          size="smallMobile"
          onClick={handlePreviousUrl}
          color="secondary"
        />
        <Button
          key="matchmaker-next-button"
          label="Volgende"
          href="/matchmaker/5"
          size="smallMobile"
          onClick={handleNextUrl}
          disabled={!inputs.subjectAreas.length}
        />
      </div>
    </MatchMakerQuestion>
  );
}

Question4.propTypes = {
  filters: vacancyFiltersType,
  handleNavigation: PropTypes.func,
};
